"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextInput = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importStar(require("react"));
const Text_1 = require("../Text");
function TextInput({ onChange, placeholder, name, id, value, className, testId, multiline, }) {
    const [focused, setFocus] = (0, react_1.useState)(false);
    const Root = multiline ? 'textarea' : 'input';
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('w-full', className), "data-testid": testId },
        placeholder && (react_1.default.createElement(Text_1.Text, { type: Text_1.TextType.UI_ELEMENT, className: (0, classnames_1.default)('text-[12px] text-disabledTextColor pl-4 pb-1', {
                'opacity-0': !focused,
            }) }, placeholder)),
        react_1.default.createElement(Root, { type: "text", name: name, id: id, value: value, className: (0, classnames_1.default)('p-3 pl-4 w-full bg-transparent border border-borderColor rounded outline-none focus:ring-transparent', { 'placeholder-transparent': focused }), placeholder: !value ? placeholder : undefined, onFocus: () => setFocus(true), onBlur: () => setFocus(false), onChange: (e) => onChange(e.target.value) })));
}
exports.TextInput = TextInput;
//# sourceMappingURL=TextInput.js.map